module.exports = __webpack_public_path__ + "img/pdf.9aa8d7e0.png";